import React, {useState, useEffect, useRef} from 'react';
import './profilesettings.css';
import Barra from '../../components/barrasuperior';
import { IoCameraOutline } from 'react-icons/io5';
import { BiLogOut, BiUser } from 'react-icons/bi';
import { useNavigate, useLocation } from 'react-router-dom';
import PersonalInfo from './settingsComponents/PersonalInfo';
import FotoPerfil from './settingsComponents/FotoPerfil';
import { useUser } from '../../context/userContext';
import Footer from '../../components/homecomponentes/footer';

function ProfileSettings() {
  const { userData } = useUser();


  return (
    <div>
      <Barra userDataPass={userData}/>
      <div className='profile-todocontainer'>
          <h1>Tu Perfil:</h1>
          <FotoPerfil/> 
          <PersonalInfo/>
      </div>
      <Footer/>
    </div>
  )
}
export default ProfileSettings